var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadgeAd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-": "",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 15v-4.5a1.5 1.5 0 0 1 3 0v4.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13h3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeAd);
export default __webpack_public_path__ + "static/media/badge-ad.40d08548772081617e1723665573a890.svg";
export { ForwardRef as ReactComponent };